import { render, staticRenderFns } from "./goods-group-info.vue?vue&type=template&id=35dd2024&"
import script from "./goods-group-info.vue?vue&type=script&lang=js&"
export * from "./goods-group-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports